// Importing React and the useState hook from the react library
import React, { useState } from 'react';

// Importing various components from the @mui/material library
import { Button, Checkbox, FormControlLabel, FormGroup, Typography, Box } from '@mui/material';

// Importing the Open Sans font
import '@fontsource/open-sans'; // Make sure the font is installed and imported

// Defining a functional component named Eternet4Ports
const Eternet4Ports = ({ text, variant, color, onClick }) => {
  // Using the useState hook to create a state variable 'checked' and an update function 'setChecked'
  const [checked, setChecked] = useState(false);

  // Defining a function to handle changes to the checkbox
  const handleCheckboxChange = (event) => {
    // Updating the 'checked' state variable with the new checkbox value
    setChecked(event.target.checked);
    // Calling the onClick function with the new checkbox value
    onClick(event.target.checked);  
  };

  // Defining a function to handle clicks on the button
  const handleButtonClick = () => {
    // Toggling the 'checked' state variable
    const newChecked = !checked;  
    setChecked(newChecked);
    // Calling the onClick function with the new checkbox value
    onClick(newChecked);  
  };

  // Returning a Box component with various child components
  return (
    <Box
      // Applying custom styles to the Box component using the sx prop
      sx={{
        // Setting the display to flex and aligning items center
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '10px',
        flexWrap: { xs: 'wrap', sm: 'nowrap' }, // Allowing wrap on small screens
        padding: '10px',
        width: '100%',
        textAlign: 'center'
      }}
    >
      {/* Button component */}
      <Button
        // Setting the onClick event handler to the handleButtonClick function
        onClick={handleButtonClick}
        
        // Setting the size of the button to small
        size="small"
        
        // Setting the variant of the button to the value of the variant prop, or 'outlined' if variant is not provided
        variant={variant || 'outlined'}
        
        // Setting the color of the button to the value of the color prop, or 'primary' if color is not provided
        color={color || 'primary'}
        
        // Applying custom styles to the button using the sx prop
        sx={{
          position: 'relative',
          right: '5%',
          fontFamily: 'Open Sans',
          color: '#363636',
          width: { xs: '100%', sm: '100%', md: '70%' }, // Responsive width
          height: { xs: '40px', sm: '40px' }, // Responsive height
          padding: { xs: '8px 12px', sm: '10px 16px' }, // Responsive padding
          margin: '0 auto',
          textTransform: 'none',
          whiteSpace: 'normal', // Allowing line breaks
          overflow: 'hidden', // Preventing overflow
          textOverflow: 'ellipsis', // Truncating text with ellipsis
          fontSize: 'clamp(10px, 4vw, 16px)', // Responsive font size
          lineHeight: '1.2', // Line height for better readability
          maxHeight: '60px' // Limiting the height to prevent very tall buttons
        }}
      >
        {/* Typography component inside the Button */}
        <Typography 
          // Setting the variant of the Typography component to 'button'
          variant="button"
          
          // Applying custom styles to the Typography component using the sx prop
          sx={{
            textTransform: 'none',
            fontSize: 'inherit', // Inheriting font size from the button
            lineHeight: '1.2', // Line height for better readability
            letterSpacing: 'normal', // Normal letter spacing
            textAlign: 'center' // Centering the text
          }}
        >
          {/* Displaying the text prop, or '4 Ethernet Ports' if text is not provided */}
          {text || '4 Ethernet Ports'}
        </Typography>
      </Button>
      
      {/* Checkbox component */}
      <FormGroup>
        <FormControlLabel
          // Creating a Checkbox component with a label
          control={
            <Checkbox
              // Setting the checked state of the Checkbox to the 'checked' state variable
              checked={checked}
              
              // Setting the onChange event handler to the handleCheckboxChange function
              onChange={handleCheckboxChange}
              
              // Applying custom styles to the Checkbox using the sx prop
              sx={{
                '& .MuiSvgIcon-root': { 
                  fontSize: '28px', 
                  position: 'relative', 
                  right: '40%' 
                } // Customizing the Checkbox icon
              }}
            />
          }
        />
      </FormGroup>
    </Box>
  );
};

// Exporting the Eternet4Ports component as the default export
export default Eternet4Ports;